module.exports = __webpack_public_path__ + "media/1fie-g-gu'unh.c345f3bf.mp3";